import React from 'react';
import ContainerRoutes from './router';
import { GlobalStyle } from './styles/globalStyles';


function App() {
  return (
    <>
    <GlobalStyle></GlobalStyle>
    <ContainerRoutes/>
    </>
  );
}

export default App;
